import { render, staticRenderFns } from "./goBuckreupST.vue?vue&type=template&id=4d525ecc"
import script from "./goBuckreupST.vue?vue&type=script&lang=js"
export * from "./goBuckreupST.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports